import React from 'react';

import {Course, useCoursesQuery} from 'src/generated/graphql';

export const getReimagineCareerCourseIds = (): string[] => {
    const REIMAGINE_CAREER_COURSE_IDS_DEV = ['2776760', '1565838', '3142166'];
    const REIMAGINE_CAREER_COURSE_IDS_PROD = [
        '6969243',
        '6969245',
        '6969251',
        '6969253',
        '6969257',
        '6969261',
    ];

    return process.env.DEPLOY_ENV === 'prod'
        ? REIMAGINE_CAREER_COURSE_IDS_PROD
        : REIMAGINE_CAREER_COURSE_IDS_DEV;
};

export interface UseReimagineCareerCoursesByIdsResult {
    count: number;
    isLoading: boolean;
    courses: Course[];
}

export const withReimagineCareerCarouselCoursesData = <T extends object>(
    WrappedComponent: React.ComponentType<
        T & {coursesResult: UseReimagineCareerCoursesByIdsResult}
    >,
): React.ComponentType<T> => {
    return (props: T) => {
        const courseIds = getReimagineCareerCourseIds();
        const {data, isLoading} = useCoursesQuery<Course[]>(
            {ids: courseIds},
            {
                enabled: Boolean(courseIds.length),
                select: (response) => response.courses.filter(Boolean) as Course[],
            },
        );

        const coursesResult = React.useMemo(
            () => ({
                count: Number(courseIds.length),
                isLoading,
                courses: data ?? [],
            }),
            [courseIds.length, isLoading, data],
        );

        return <WrappedComponent {...props} coursesResult={coursesResult} />;
    };
};
